import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { FormattedMessage } from 'react-intl';
import BookingPreview from 'components/BookingInfo/creation-preview';
import AcceptanceTermsText from 'components/BookingInfo/ActionFooter/acceptance-terms-text';
import CircularProgress from 'components/shared/CircularProgress';
import { Checkbox } from 'components/FormInputs';
import moment from 'logic/moment';

const CreatePreview = ({
  submitBookingForm,
  currentUser,
  users,
  cottages,
  cancellationPolicy,
  setEditMode,
  overlap,
  loading,
  initialValues,
}) => {
  const [overlapAccepted, setOverlapAccepted] = React.useState(false);
  const [terms, setTerms] = React.useState(false);
  const cottage = cottages.find((c) => c.id === parseInt(initialValues.cottage_id, 10));
  const otherUsers = users.filter((user) => user.id !== currentUser.id);

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Box>
      <Box>
        <BookingPreview
          isHost
          overlap={overlap}
          booking={{
            ...initialValues,
            number_of_guests: parseInt(initialValues.number_of_guests, 10),
            total_price: initialValues.total_price * 100,
            Host: currentUser,
            Guest: otherUsers && otherUsers[0],
          }}
          cottage={{
            cottagePic: cottage.images[0]?.url,
            ...cottage,
          }}
          cancellationPolicy={cancellationPolicy.find(
            (cp) => cp.id === parseInt(initialValues.cancellation_policy_id, 10),
          )}
          setEditMode={setEditMode}
          overlapAccepted={overlapAccepted}
          setOverlapAccepted={setOverlapAccepted}
        />
      </Box>
      <Box>
        {(!overlap || !overlap.length || overlapAccepted) && (
          <>
            <Box m={2}>
              <Checkbox
                name="termsOfService"
                value={terms}
                onChange={(e) => {
                  const { checked } = e.target;

                  setTerms(checked);
                }}
                label={
                  <AcceptanceTermsText
                    booking={{ ...initialValues, created_at: moment().format() }}
                  />
                }
              />
            </Box>
            <Box textAlign="center" p={2}>
              <Button
                variant="contained"
                color="secondary"
                onClick={setEditMode}
                style={{ marginBottom: '8px' }}
              >
                <FormattedMessage id="Back" defaultMessage="Back" />
              </Button>
              &nbsp;
              <Button
                variant="contained"
                color="primary"
                disabled={!terms}
                onClick={submitBookingForm}
                type="button"
                style={{ marginBottom: '8px' }}
              >
                <FormattedMessage id="bookingForm.sendOffer" defaultMessage="SEND BOOKING OFFER" />
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

CreatePreview.propTypes = {
  submitBookingForm: PropTypes.func.isRequired,
  currentUser: PropTypes.shape({
    id: PropTypes.number,
  }),
  users: PropTypes.arrayOf(PropTypes.shape({})),
  cottages: PropTypes.arrayOf(PropTypes.shape({})),
  cancellationPolicy: PropTypes.arrayOf(PropTypes.shape({})),
  setEditMode: PropTypes.func.isRequired,
  overlap: PropTypes.arrayOf(PropTypes.shape({})),
  loading: PropTypes.bool,
  initialValues: PropTypes.shape({
    number_of_guests: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    cottage_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    total_price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    cancellation_policy_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

export default CreatePreview;
